module.exports = __webpack_public_path__ + "img/comp_clover-hs.98175425.png";